import gql from 'graphql-tag';

const NAME =
  'DealerDetails_RotationOverrideContactsModal_overrideRotationContactsMutation';

export default gql`
  mutation ${NAME} ($id: ID!, $patch: AfterHoursEventUpdatePatch!) {
    updateAfterHoursEvent(input: { id: $id patch: $patch }) {
      event {
        id
        startDate
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/RotationOverrideContactsModal/overrideRotationContactsMutation.js